import { CONFIG } from '../core/config';
import { RiskMatrixBand } from './admin/risk-matrices/risk-matrix-band';
import { DashboardWidget } from './dashboard/dashboard-widget';
import { RunnableModel } from './runnable-model';
import { ViewModel } from './view-model';

export class DashboardData implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Dashboard';
  readonly apiRoute: string = CONFIG.apiRoutes.dashboardData;

  public dashboardId: string;
  public riskMatrixBands: RiskMatrixBand[] = new Array<RiskMatrixBand>();
  public defaultRiskMatrix: string;
  public riskModels: RunnableModel[] = new Array<RunnableModel>();
  public highRiskItemRiskBandFilterValues: string[] = new Array<string>();
  public dashboardWidgets: DashboardWidget[] = new Array<DashboardWidget>();

  json() {
    return this;
  }

  loadFromJson(data) {
    if (data.dashboardId) {
      this.dashboardId = data.dashboardId;
    }

    if (data.widgets) {
      data.widgets.forEach(widget => {
        const dashboardWidget = new DashboardWidget();
        dashboardWidget.loadFromJson(widget);
        this.dashboardWidgets.push(dashboardWidget);
      });
    }

    if (data.riskMatrixBands) {
      data.riskMatrixBands.forEach(band => {
        this.riskMatrixBands.push(band);
      });
    }

    if (data.riskModels) {
      data.riskModels.forEach(band => {
        this.riskModels.push(band);
      });
    }

    if (data.highRiskItemRiskBandFilterValues) {
      data.highRiskItemRiskBandFilterValues.forEach(band => {
        this.highRiskItemRiskBandFilterValues.push(band);
      });
    }

    if (data.defaultRiskMatrix) {
      this.defaultRiskMatrix = data.defaultRiskMatrix;
    }
  }
}
